import React, { useRef, useCallback, useEffect } from 'react';
import { Input } from '../Input/Input';

interface ParameterEditorSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    className="w-4 h-4"
  >
    <path
      fillRule="evenodd"
      d="M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z"
      clipRule="evenodd"
    />
  </svg>
);

export const ParameterEditorSearchBar: React.FC<ParameterEditorSearchBarProps> = ({
  value,
  onChange,
  placeholder = 'Buscar campo a configurar',
}) => {
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;

      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }

      debounceRef.current = setTimeout(() => {
        onChange(newValue);
      }, 300);
    },
    [onChange]
  );

  return (
    <Input
      startIcon={SearchIcon as React.ReactElement}
      placeholder={placeholder}
      defaultValue={value}
      onChange={handleChange}
    />
  );
};
